import { useEffect, useState } from 'react';
import { DEFAULT_DEBOUNCE_TIME } from '@/constants/static';

export function useDebounce<T>(value: T, delay: number = DEFAULT_DEBOUNCE_TIME): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedValue(value), delay);

		return () => {
			clearTimeout(timer);
		};
	}, [value, delay]);

	return debouncedValue;
}
